import { render, staticRenderFns } from "./ProgramEmpty.vue?vue&type=template&id=15abf299&scoped=true&"
import script from "./ProgramEmpty.vue?vue&type=script&lang=js&"
export * from "./ProgramEmpty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15abf299",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/geras/Documents/electros/magic-electros-crm/vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('15abf299')) {
      api.createRecord('15abf299', component.options)
    } else {
      api.reload('15abf299', component.options)
    }
    module.hot.accept("./ProgramEmpty.vue?vue&type=template&id=15abf299&scoped=true&", function () {
      api.rerender('15abf299', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/vue/pages/LeadView/tabs/program/ProgramEmpty.vue"
export default component.exports